import {
  ArrowTrendingUpIcon,
  BanknotesIcon,
  CurrencyDollarIcon,
  InformationCircleIcon,
  ReceiptPercentIcon,
} from "@heroicons/react/24/solid";
import { useQuery } from "react-query";
import { useCookie } from "../../../hooks/useCookie";
import apiService from "../../../service/apiService";
import { formatMad } from "../../../helpers/general";


type CommissionInfo = {
  total: { amount: number; commission: number };
  pending: { toReceive?: number; toPay: number };
};

function EarningCard({
  label,
  value,
  icon: Icon,
  bg,
  color,
}: {
  label: string;
  value?: string;
  icon: typeof ArrowTrendingUpIcon;
  bg: string;
  color: string;
}) {
  return (
    <div className="col-sm-6 col-xl-3">
      <div className="bg-white rounded-4 shadow-sm p-4 h-100">
        <span
          className="d-inline-flex align-items-center justify-content-center rounded-4"
          style={{ width: 44, height: 44, background: bg, color }}
        >
          <Icon width={20} height={20} />
        </span>
        <p className="text-sm text-secondary mt-4 mb-1">{label}</p>
        <p className="fs-5 fw-bold mb-0">{value ?? "…"}</p>
      </div>
    </div>
  );
}

export default function PartnerEarningsTab({
  partnerId,
}: {
  partnerId: string;
}) {
  const { token } = useCookie("vToken");
  const { data } = useQuery(["partnerCommission", partnerId], () =>
    apiService.MakeGetRequest(
      `booking/partner/commission-info/${partnerId}`,
      token,
    ),
  ) as { data?: CommissionInfo };

  return (
    <div className="mt-3">
      <div className="row g-3">
        <EarningCard
          label="Ventes générées"
          value={data && formatMad(data.total.amount)}
          icon={ArrowTrendingUpIcon}
          bg="#fff1e7"
          color="#ff7722"
        />
        <EarningCard
          label="Commission gagnée"
          value={data && formatMad(data.total.commission)}
          icon={ReceiptPercentIcon}
          bg="#eaf8ef"
          color="#239b4a"
        />
        <EarningCard
          label="À recevoir de Venez"
          value={data && formatMad(data.pending.toReceive ?? 0)}
          icon={CurrencyDollarIcon}
          bg="#e8f6ff"
          color="#1d7fb3"
        />
        <EarningCard
          label="À régler à Venez"
          value={data && formatMad(data.pending.toPay)}
          icon={BanknotesIcon}
          bg="#fff6d8"
          color="#bd8300"
        />
      </div>

      <div
        className="bg-gradient-primary text-white rounded-4 p-4 mt-4"
        style={{ maxWidth: 440 }}
      >
        <InformationCircleIcon width={24} height={24} />
        <h6 className="fw-bold mt-2">Comment ça marche ?</h6>
        <p className="text-sm mb-2">
          Espèces : le partenaire garde sa commission, le reste est à régler à
          Venez.
        </p>
        <p className="text-sm mb-0">
          Carte, Stripe ou Wafacash : Venez encaisse le client et reverse la
          commission au partenaire.
        </p>
      </div>
    </div>
  );
}
